import React from 'react';
import AdsModule from './modules/AdsModule';
import CheckoutModule from './modules/CheckoutModule';
import SignatureModule from './modules/SignatureModule';
import TextModule from './modules/TextModule';

const MODULE_MAP = {
	ads: AdsModule,
	checkout: CheckoutModule,
	signature: SignatureModule,
	text: TextModule
};

const KioskSurface = ({contentBlocks, kioskSession}) => {
	if (!contentBlocks || !contentBlocks.length) {
		return <div>No kiosk content configured.</div>;
	}

	return (
		<div>
			{contentBlocks.map((block, index) => {
				const Module = MODULE_MAP[block.type];
				const blockKey = block.type ? `kiosk-module-${block.type}` : `kiosk-module-${index}`;
				if (!Module) {
					return (
						<div key={blockKey} style={{marginBottom: '16px'}}>
							Unsupported module type: {block.type}
						</div>
					);
				}
				return (
					<div key={blockKey} style={{marginBottom: '16px'}}>
						<Module config={block.config || {}} kioskSession={kioskSession}/>
					</div>
				);
			})}
		</div>
	);
};

export default KioskSurface;
